import { useContext } from 'react';
import { ToastMessageContext } from '../context/ToastMessageContext/toast-message.context';

export const useMessage = () => useContext(ToastMessageContext);
